import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory, useParams } from 'react-router-dom';
import axios from "axios";
import { AppSettings } from "../../config/app-settings.js";
import Preloader from "../../components/custom/preLoader";
import showErrorToast, { showSuccessToast } from "../../components/toast/toast";
import { CheckUserExpiry, setAuthTokens } from "../../components/content/axiosConfig.js";

const ResetPassword = () => {
    const context = useContext(AppSettings); 
    const history = useHistory();
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const { handleSetAppSidebarNone, handleSetAppHeaderNone, handleSetAppContentClass } = context;

        handleSetAppSidebarNone(true);
        handleSetAppHeaderNone(true);
        handleSetAppContentClass("p-0");

        return () => {
            handleSetAppSidebarNone(false);
            handleSetAppHeaderNone(false);
            handleSetAppContentClass("");
        };
    }, [context]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (password !== confirmPassword) {
            showErrorToast("Password and confirm password must match.");
            setIsLoading(false);
            return;
        }

        try {
            let API_URL = "";
            if (process.env.REACT_APP_Environment === 'development')
                API_URL = process.env.REACT_APP_API_URL;
            else
                API_URL = process.env.REACT_APP_API_URL_Production;

            const response = await axios.post(`${API_URL}api/User/resetPassword`, {
                token,
                password,
            });

            if (response.status === 200) {
                const { token: accessToken, refreshToken, User } = response.data;
                setAuthTokens(accessToken, refreshToken, User);
                await CheckUserExpiry();
                showSuccessToast("Password reset successfully. Welcome back!");
                history.push('/');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred.";
            showErrorToast(errorMessage);
            console.error("Error resetting password:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (event) => {
        const { id, value } = event.target;
        if (id === "password") {
            setPassword(value);
        } else if (id === "confirmPassword") {
            setConfirmPassword(value);
        }
    };

    return (
        isLoading ? <Preloader /> :
        <div className="login login-with-news-feed">
            <div className="news-feed">
                <div
                    className="news-image"
                    style={{
                        backgroundImage: "url(/assets/img/login-bg/login-bg-11.jpg)",
                    }}
                ></div>
                <div className="news-caption">
                    <h4 className="caption-title">
                        <b>SSF</b> Fishing
                    </h4>
                    <p>
                        SSF Fishing is a leading platform in the fisheries industry, offering a comprehensive system to efficiently manage and optimize your fisheries operations
                    </p>
                </div>
            </div>
            <div className="login-container">
                <div className="login-header mb-30px">
                    <div className="brand">
                        <div className="d-flex align-items-center">
                            <span className="logo"></span>
                            <b>SSF</b> Fishing
                        </div>
                        <small>Admin Panel</small>
                    </div>
                    <div className="icon">
                        <i className="fa fa-sign-in-alt"></i>
                    </div>
                </div>
                <div className="login-content">
                    <form onSubmit={handleSubmit} className="fs-13px">
                        <div className="form-floating mb-15px">
                            <input
                                type="password"
                                className="form-control h-45px fs-13px"
                                placeholder="Enter new password"
                                id="password"
                                name="password"
                                value={password}
                                onChange={handleChange}
                                required
                            />
                            <label
                                htmlFor="password"
                                className="d-flex align-items-center fs-13px text-gray-600"
                            >
                                Password
                            </label>
                        </div>
                        <div className="form-floating mb-15px">
                            <input
                                type="password"
                                className="form-control h-45px fs-13px"
                                placeholder="Confirm new password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={handleChange}
                                required
                            />
                            <label
                                htmlFor="confirmPassword"
                                className="d-flex align-items-center fs-13px text-gray-600"
                            >
                                Confirm Password
                            </label>
                        </div>
                        <div className="mb-15px">
                            <button
                                type="submit"
                                className="btn btn-success d-block h-45px w-100 btn-lg fs-14px"
                            >
                                Set New Password
                            </button>
                        </div>
                        <div className="mb-4 pb-5">
                            Don't have an account? Click <Link to="/user/register">here</Link> to Register.
                        </div>
                        <hr className="bg-gray-600 opacity-2" />
                        <div className="text-gray-600 text-center text-gray-500-darker mb-0">
                            © SSF Fishing. All Rights Reserved
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;